import React from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@components-library/Icons/SvgIcon';
import { keyMap } from '@locales/lokalise/keyMap';
import SignOutIcon from 'assets/icons/sign out normal.svg';
import cn from 'classnames';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';

interface IProps {
  isMobileMenu?: boolean;
}

const SignOut: React.FC<IProps> = observer(({ isMobileMenu }) => {
  const { i18n } = useTranslation();
  const { authStore } = useMobxStore();

  return (
    <button
      type="button"
      className={cn('signout', { 'sidebar-panel__link': isMobileMenu })}
      onClick={() => authStore.signOut()}>
      <SvgIcon className="signout__icon" src={SignOutIcon} />
      <span className="signout__text">{i18n.t(keyMap.accountSignOutBtn)}</span>
    </button>
  );
});

export default SignOut;
